import React from 'react';

import { SSkeletonBodyText, SSkeletonDisplayText } from 'components/shared/s-polaris';

interface ProviderRatesPreviewSkeletonProps {
    /** Number of provider cards to render. */
    sections?: number;
    /** Number of placeholder rate rows per card. */
    rowsPerSection?: number;
}

// Shared loading placeholder for ShippingRatesPreview and HomeDeliveryPreview — mirrors the
// provider card layout both use (heading/description + a handful of rate rows).
export const ProviderRatesPreviewSkeleton: React.FC<ProviderRatesPreviewSkeletonProps> = ({
    sections = 2,
    rowsPerSection = 2,
}) => {
    return (
        <>
            {Array.from({ length: sections }).map((_, index) => (
                <s-section key={index}>
                    <div className="flex flex-col gap-3">
                        <div className="flex flex-col gap-1.5">
                            <SSkeletonDisplayText height="20px" maxWidth="200px" />
                            <SSkeletonBodyText lines={1} minWidth="320px" />
                        </div>
                        {Array.from({ length: rowsPerSection }).map((_, rowIndex) => (
                            <div
                                key={rowIndex}
                                className="flex flex-col gap-2 py-2 px-4 rounded-lg border border-border"
                            >
                                <SSkeletonDisplayText height="18px" maxWidth="140px" />
                                <div className="flex gap-2">
                                    <div className="h-6 w-24 rounded-full bg-bg-fill-tertiary" />
                                    <div className="h-6 w-20 rounded-full bg-bg-fill-tertiary" />
                                </div>
                            </div>
                        ))}
                    </div>
                </s-section>
            ))}
        </>
    );
};
